<template>
    <div class="stat-container">
        <div class="stat-title">
            {{ title }}
        </div>
        <div class="stat-content">
            <div class="stat-number">
                {{ formattedNumber }}
            </div>
            <div class="stat-unit">
                {{ unit }}
            </div>
        </div>
    </div>
</template>
<script>
import {
  formatCommaNumber,
  oneBtnDialog,
} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
export default {
    components: {
    },
    computed: {
        formattedNumber() {
            if(this.unit === '%') return this.number.toFixed(1);
            return formatCommaNumber(this.number);
        }   
    },
    props: {
        title: String,
        number: Number,
        unit: String,
    },
    watch: {
    },
    data() {
        return {
        }
    },
    async mounted() {
    },
    methods: {

    }
}
</script>
<style lang="scss">
</style>
<style scoped lang="scss">
$Gray-5: #D1D6DB;
$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$SkyBlue : #E1F0FF;
$Blue : #278AEC;
$Red: #F55247;
$Pink: #F8948E;
$Orange: #FFA50A;
$Green: #22BF22;

.stat-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    .stat-title {
        font-size: 12px;
        font-weight: 400;
        color: $Gray-60;
    }
    .stat-content {
        display: flex;
        align-items: end;
        justify-content: center;
        gap: 4px;
        .stat-number {
            font-size: 30px;
            font-weight: 700;
            display: flex;
            align-items: end;
            justify-content: center;
            line-height: 1.1;
        }
        .stat-unit {
            font-size: 16px;
            font-weight: 400;
        }
    }   
}
</style>